/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import BaseApi from '../api/BaseApi';
import type {ShellApi as Contract, ExtendedShellInfoObject} from '@adobe/exc-app/shell';
import {Events} from '@exc/shared';

export class ShellApi extends BaseApi implements Contract {
  protected apiEvents = ['cdn', 'environment', 'imsEnvironment', 'shellInfo'];
  protected trackData = ['shellInfo'];
  protected keyPrefix = 'shell';

  public getExtendedShellInfo(): Promise<ExtendedShellInfoObject> {
    this.metrics.event('Runtime.getExtendedShellInfo');
    return this.sendAndReceive(Events.EXTENDED_SHELL_INFO);
  }
}
